import { ISearchViewFactoryParameters } from '#/DefaultViewExtensionInterfaces';
import ViewFactory from '@/Factories/ViewFactory';
import type SearchViewViewModel from '@/Components/SearchView/SearchViewViewModel';
import type SearchView from '@/Components/SearchView/SearchView';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import { ISearchQueryDTO } from "coreframetypings/dto";
import UserSpecificDataHelper from '@/Utility/UserSpecificDataHelper';
import RADApplication from '@/Management/RADApplication';

export default class SearchViewFactory extends ViewFactory {
    private SearchViewViewModel = ComponentManager.getViewModel<typeof SearchViewViewModel>('SearchViewViewModel');
    private SearchView = ComponentManager.getView<typeof SearchView>('SearchView');

    /**
     * @override
     */
    public viewModel: SearchViewViewModel;

    /**
     * @override
     */
    public view: SearchView;

    /**
     * Die Seite der Suche
     */
    public page: number;

    /**
     * Die Seitengröße der Suche
     */
    public pageSize: KnockoutComputed<number>;

    /**
     * Die Query für die Suche
     */
    public query: string;

    public searchQuery: ISearchQueryDTO;

    constructor(params: ISearchViewFactoryParameters) {
        super(params);

        this.page = this.paramOrDefault(params.Page, 1, this.getInt);
        this.pageSize = UserSpecificDataHelper.loadUserSpecificData(this.name + 'View_PageSize', RADApplication.getInstance().configuration.possibleListViewPages[0]);

        if (params.PageSize != undefined)
            this.pageSize(params.PageSize);

        this.query = this.paramOrDefault(params.Query, null);
        this.searchQuery = this.paramOrDefault(params.SearchQuery, null);
    }

    public getRegion(): string {
        return 'Content';
    }

    public getView() {
        this.resolveDependencies(['Wireframe']);

        if (this.viewModel == null || this.viewModel.isDisposed) {
            this.viewModel = new this.SearchViewViewModel({
                viewFactory: this,
                locator: 'search-view'
            });
        }

        if (this.view == null) {
            this.view = new this.SearchView(this.viewModel, this.createRootElement('Search'));
        }

        this.setPageTitle(ResourceManager.getInstance().get('SEARCH_TITLE'));
        this.viewModel.raiseHeaderChange();

        var tuple = this.view.getTuple();
        return tuple.view;
    }

    private getInt(value: any, def: number) {
        if (typeof value == "number") 
            return value;

        const number = parseInt(value);
        return isNaN(number) ? def : number;
    }

    public refresh(): boolean {
        return false;
    }
}

ComponentManager.setFactory('Search', SearchViewFactory, 'RADPresentation.HTMLClient.DefaultViewExtensions');